import React from 'react'
import { Link, VisuallyHidden } from '@overdose/components'
import { IconArrowRight } from '@tabler/icons-react'
import classNames from 'classnames'

import { Image } from '~/components/Image'
import { getImageSrc } from '~/helpers'
import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './ProjectCard.module.css'
import { ProjectCardProps } from './ProjectCard.types'

export const ProjectCard = ({
  image,
  title,
  url,
  backgroundColor,
  imageFit,
  isMobileCarouselDisabled,
  cardTitleColor,
}: ProjectCardProps) => {
  return (
    <div
      className={classNames(
        styles.card,
        'p-4 md:p-6 relative rounded-md overflow-hidden',
        {
          [styles.mobileCarouselDisabledCard]: isMobileCarouselDisabled,
          'bg-white': !backgroundColor,
        }
      )}
      style={{
        backgroundColor,
      }}>
      {url && <Link to={url} className='absolute z-10 inset-0' />}
      {image && (
        <Image
          title={title}
          src={getImageSrc(image.src, '350')}
          addSrcSet={false}
          alt={image.altText}
          width={image.width}
          height={image.height}
          className={classNames(
            imageFit === 'cover'
              ? 'object-cover absolute inset-0 h-full w-full'
              : 'pb-5 object-contain w-full'
          )}
        />
      )}
      <div
        className={classNames(
          'flex w-full justify-between items-center',
          imageFit === 'cover'
            ? 'absolute md:bottom-8 bottom-4 left-0 md:px-6 px-4'
            : ''
        )}>
        <Typography
          tag={TypographyTag.span}
          variant={TypographyVariant.Heading5}
          className={classNames('tracking-little', {
            [styles.title]: !cardTitleColor,
          })}
          style={
            {
              '--color-typography-heading': cardTitleColor,
            } as React.CSSProperties
          }>
          {title}
        </Typography>
        <div
          className={classNames(
            'rounded-full bg-white',
            'flex justify-center items-center',
            'md:w-12 w-10 md:h-12 h-10'
          )}>
          <IconArrowRight
            size={18}
            color='var(--btn-solid-color-text-secondary)'
            strokeWidth={3}
          />
          <VisuallyHidden>{title}</VisuallyHidden>
        </div>
      </div>
    </div>
  )
}
